var map = {
	"./1.png": 4114,
	"./M1.png": 6789,
	"./product1.png": 1477,
	"./product2.png": 4126,
	"./product3.png": 2439,
	"./product4.png": 7272,
	"./product5.png": 5137,
	"./product6.png": 4970,
	"./product7.png": 2547,
	"./product8.png": 4884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6635;